import { Outlet, useNavigate } from "react-router-dom";
import SettingsSideBar from "../../components/Settings/SettingsSidebar";
import { useEffect } from "react";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { toast } from "react-toastify";

const Settings = () => {
  const navigate = useNavigate();
  const { SelectedOrg } = useStateGetter();

  useEffect(() => {
    if (!SelectedOrg.orgName) {
      navigate("/home");
      toast("Select an Org/Business or Create one", {
        toastId: "customId",
      });
    }
  }, []);
  return (
    <div className="h-full w-screen flex mt-4 ">
      <div className="w-[30vw] px-14 h-full">
        <SettingsSideBar />
      </div>

      <div className=" w-[70vw] flex justify-start items-start ">
        <Outlet />
      </div>
    </div>
  );
};

export { Settings };
